import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import type {} from '@redux-devtools/extension';

import storage from '../storage';
import {
  resetPatientInfo,
  sessionStarted,
  updatePatientInfo,
} from './patient-store.actions';
import { initialState, STORE_NAME } from './patient-store.constant';
import { PatientActions, PatientState } from './patient-store.types';

export const usePatientStore = create<PatientState & PatientActions>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        updatePatientInfo: updatePatientInfo(set, get),
        resetPatientInfo: resetPatientInfo(set),
        sessionStarted: sessionStarted(set, get),
      }),
      { name: STORE_NAME, storage: createJSONStorage(() => storage) }
    ),
    { name: STORE_NAME }
  )
);
